import MessageList from "./MessageList";
import SingleMessage from "./SingleMessage";
import "./message.css";
import { useGlobalContext } from "../../../Context/Context";

const Message = ({ checkBack, setCheckBack, currentTab, selectedCompany }) => {
  const { currentChatAdmin, setCurrentChatAdmin } = useGlobalContext();
  return (
    <div className="left-side-message">
      {!checkBack ? (
        <MessageList
          setCurrentChat={setCurrentChatAdmin}
          setCheckBack={setCheckBack}
          selectedCompany={selectedCompany}
        />
      ) : (
        <SingleMessage
          currentChat={currentChatAdmin}
          setCurrentChat={setCurrentChatAdmin}
          setCheckBack={setCheckBack}
          currentTab={currentTab}
          isFullVisible={true}
          checkBack={checkBack}
          selectedCompany={selectedCompany}
        />
      )}
    </div>
  );
};

export default Message;
